<template lang="pug">
  .layout
    y-dialog(v-model="showModal" fill-height fluid scrollable persistent transition="fade-transition" max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")

      v-card(flat)
        v-card-title.pa-0
          v-row.px-5.pt-3.pb-2(v-if="hasChanges" no-gutters align="center" :style="`background-color: ${$vuetify.theme.themes[$theme].success600}`")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].basic100" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.basic100--text {{ $t('save_changes') }}
            v-col.ml-3.shrink
              v-layout
                v-btn.mr-2.my-auto(depressed small outlined color="basic100" @click="clickRevert()")
                  .button-AA-small.basic100--text {{ $t('cancel') }}
                v-btn.my-auto.basic100(depressed small @click="clickSave()" :loading="isLoading")
                  .button-AA-small.primary500--text {{ $t('save') }}
          
          v-row.px-5.pt-3.pb-2(v-else no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.primary500--text {{ $t('local_delivery') }}

        v-layout.my-6(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

        v-card-text.pa-0.pb-12(v-else)
          .header.px-4.mt-4
            .s1 Yezza Shipping
            .c1.basic600--text {{ $t('yezza_shipping_text') }}
            a.c1.textColorAccent--text.text-decoration-none(href="https://help.yezza.com/hc/en-my/articles/4412895578265-What-is-Yezza-Shipping-" target="_blank") Learn more
          
          v-form.mt-4(ref="form")
            v-card.pt-4.mx-4(flat style="border:1px solid var(--v-basic300);")
              .header.px-4
                .s1 {{ $t('on_demand_services') }}
                .p1.mt-2 {{ $t('on_demand_services_text') }}:

              .localdelivery.pr-4.pl-2(v-for="(localdelivery, index) in localdelivery.shipping_const" :key="localdelivery.id")
                v-divider.basic300(v-if="index != 0")
                v-row(align='center')
                  v-col.shrink
                    y-switch.mb-n3.mr-n3(:color="$vuetify.theme.themes[$theme].success400" v-model="shippingObject(localdelivery).enabled" @change="onUpdateLocalDelivery(shippingObject(localdelivery), true)" :disabled="shippingObject(localdelivery).out_of_service")
                  v-col.clickable(@click.stop="shippingObject(localdelivery).out_of_service ? '' : openLocalDeliveryDetails(shippingObject(localdelivery))")
                    v-row(align='center')
                      v-col
                        .s2.basic700--text {{ localdelivery.name }}
                        .c1.basic600--text(v-if="shippingObject(localdelivery).out_of_service") {{ $t('not_available_your_area') }}
                      v-col.shrink.pr-0(v-if="shippingObject(localdelivery).preferred")
                        v-chip(x-small outlined color="basic600" :style="{ 'background-color': $vuetify.theme.themes[$theme].basic600T08 + '!important' }")
                          .c1.basic600--text {{ $t('preferred') }}
                      v-col.shrink
                        eva-icon.mt-1(name="arrow-ios-forward-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="20" height="20")
            
            v-card.pa-4.mx-4.mt-4(flat style="border:1px solid var(--v-basic300);")
              .s1 {{ $t('delivery_rates') }}
              v-row
                v-col
                  .s2.basic700--text {{ $t('use_automatic_delivery_rates') }}
                  .c1.basic600--text {{ $t('charge_based_on_weight') }}
                v-col.shrink
                  y-switch(:color="$vuetify.theme.themes[$theme].success400" v-model="useAutomaticShippingRate")
              
              .enable(v-if="!useAutomaticShippingRate")
                v-divider.basic300
                .custom.mt-4
                  .p1.basic800--text {{ $t('customize_shipping_rate') }}
                  v-radio-group.mt-n1(v-model="customShippingRate" hide-details)
                    v-radio.mt-3(value='markup' style="width:100%" color="textColorAccent")
                      template(v-slot:label)
                        div.s2.textColorDefault--text {{ $t('markup_rates') }}Markup rates
                    .details.ml-8
                      .c1.basic600--text {{ $t('markup_rates_text') }}C
                      .amount.mt-4(v-if="customShippingRate == 'markup'")
                        .mb-1.label.basic600--text.text-uppercase {{ $t('markup_amount') }}
                        v-text-field.mt-2(v-model='markupAmount' placeholder="0" background-color="basic200" outlined dense height="40" type="number" :rules="rules.has_quantity" :prefix="$currency.symbol" hide-details="auto")
                        .c1.basic600--text.mt-2 {{ $t('markup_amount_text') }}
                        .c1.basic600--text.mt-2 {{ $t('markup_example') }}
                        div.ml-13
                          .c1.basic600--text {{ $t('markup_example_time') }}
                          .c1.basic600--text {{ $t('markup_example_fee') }}
                    v-divider.basic300.my-4
                    v-radio.mt-3(value='flat' style="width:100%" color="textColorAccent")
                      template(v-slot:label)
                        div.s2.textColorDefault--text {{ $t('flat_rate') }}
                    .details.ml-8
                      .c1.basic600--text {{ $t('flat_rate_text') }}
                      .amount.mt-4(v-if="customShippingRate == 'flat'")
                        .mb-1.label.basic600--text.text-uppercase {{ $t('flat_rate') }}
                        v-text-field.mt-2(v-model='flatAmount' placeholder="0" background-color="basic200" outlined dense height="40" type="number" :rules="rules.has_quantity" :prefix="$currency.symbol" hide-details="auto")
                        .c1.basic600--text.mt-2 {{ $t('flat_rate_info') }}
            
            v-card.pa-4.mx-4.mt-4(flat style="border:1px solid var(--v-basic300);")
              .s1 {{ $t('section_offer_free.title') }}
              v-row
                v-col
                  .c1.basic600--text.mt-3 {{ $t('section_offer_free.pays_full') }}
                v-col.shrink
                  y-switch(:color="$vuetify.theme.themes[$theme].success400" v-model="localdelivery.free_shipping_enabled")
              
              .disable(v-if="localdelivery.free_shipping_enabled")
                v-divider.basic300
                .price.mt-4
                  .mb-1.label.basic600--text.text-uppercase {{ $t('section_offer_free.order_amount') }}
                  v-text-field.mt-2(v-model='orderAmount' placeholder="0" background-color="basic200" outlined dense height="40" type="number" :rules="rules.has_quantity" :prefix="$currency.symbol" hide-details="auto")
                  .c1.basic600--text.mt-2 {{ $t('section_offer_free.order_amount_text') }}

            v-card.py-4.mx-4.mt-4(flat style="border:1px solid var(--v-basic300);")
              .header.px-4
                .s1 {{ $t('section_address.title') }}
                .c1.basic600--text {{ $t('section_address.text') }}
              
              v-divider.basic300.my-4
              
              .pickup-address.px-4
                v-row.pa-0.clickable(@click="showUpdateLocalDeliveryAddress = true")
                  v-col.py-0(v-if="localdelivery.pickup_address")
                    .label.basic600--text.text-uppercase.my-auto {{ $t('section_address.pickup_address') }}
                    .p2.basic700--text {{ localdelivery.pickup_address.address_1 }}, {{ localdelivery.pickup_address.address_2 }}, {{ localdelivery.pickup_address.postcode }}, {{ localdelivery.pickup_address.city }}, {{ localdelivery.pickup_address.state }}, {{ localdelivery.pickup_address.country }}
                    .p2.basic700--text(v-if="localdelivery.pickup_address.phone") {{ localdelivery.pickup_address.phone | phoneFormat }}
                  v-col.py-0.shrink
                    eva-icon(name="arrow-ios-forward-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="20" height="20")

    .modals
      local-delivery-method(v-if="showUpdateLocalDeliveryMethod" :open.sync="showUpdateLocalDeliveryMethod" :localdelivery.sync="localdelivery" :shipping="selectedShipping" @update-enabled="onUpdateLocalDelivery")
      local-delivery-address(v-if="showUpdateLocalDeliveryAddress" :open.sync="showUpdateLocalDeliveryAddress" :company.sync="company" @check-address="updateAddress()" @finished="fetchShippingLocalDelivery()" :isEditing="true" :localdelivery.sync="localdelivery")
            
</template>

<script>
import { mapActions } from 'vuex'
import LocalDeliveryMethod from '@/components/dialogs/settings/yezzashipping/LocalDeliveryMethod.vue'
import LocalDeliveryAddress from '@/components/dialogs/settings/yezzashipping/LocalDeliveryAddress.vue'

export default {
  name: 'LocalDeliverySettings',
  components: { LocalDeliveryMethod, LocalDeliveryAddress },
  props: ['open', 'company'],
  data: () => ({
    isFetching: false,
    originalLocalDelivery: null,
    localdelivery: {},
    selectedShipping: null,
    showUpdateLocalDeliveryMethod: false,
    showUpdateLocalDeliveryAddress: false,
    addressChanged: false,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required']
    }
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    hasChanges () {
      if (Object.keys(this.localdelivery).length > 0 && JSON.stringify(this.localdelivery) !== JSON.stringify(this.originalLocalDelivery)) {
        return true
      }
      return false
    },
    useAutomaticShippingRate: {
      get() {
        if (Object.keys(this.localdelivery).length > 0) {
          return !this.localdelivery.custom_rates_enabled
        }
        return false
      },
      set(newValue) {
        this.localdelivery.custom_rates_enabled  = !newValue
      }
    },
    customShippingRate: {
      get() {
        if (Object.keys(this.localdelivery).length > 0) {
          if (this.localdelivery.flat_rate != null) {
            return 'flat'
          }
          if (this.localdelivery.markup_rate != null) {
            return 'markup'
          }
        }
        return null
      },
      set(newValue) {
        if (newValue == 'flat') {
          if (this.originalLocalDelivery && this.originalLocalDelivery.flat_rate) {
            this.localdelivery.flat_rate = this.originalLocalDelivery.flat_rate
          } else {
            this.localdelivery.flat_rate = 0
          }
          this.localdelivery.markup_rate = null
        } else {
          if (this.originalLocalDelivery && this.originalLocalDelivery.markup_rate) {
            this.localdelivery.markup_rate = this.originalLocalDelivery.markup_rate
          } else {
            this.localdelivery.markup_rate = 0
          }
          this.localdelivery.flat_rate = null
        }
      }
    },
    markupAmount: {
      get() {
        if (Object.keys(this.localdelivery).length > 0) {
          return this.localdelivery.markup_rate/this.$currency.multiplier
        }
        return 0
      },
      set(newValue) {
        this.localdelivery.markup_rate = parseInt((parseFloat(newValue)).toFixed(this.$currency.exponent).replace('.', ''))
      }
    },
    flatAmount: {
      get() {
        if (Object.keys(this.localdelivery).length > 0) {
          return this.localdelivery.flat_rate/this.$currency.multiplier
        }
        return 0
      },
      set(newValue) {
        this.localdelivery.flat_rate = parseInt((parseFloat(newValue)).toFixed(this.$currency.exponent).replace('.', ''))
        this.localdelivery.markup_rate = null
      }
    },
    orderAmount: {
      get() {
        if (Object.keys(this.localdelivery).length > 0) {
          return this.localdelivery.free_shipping/this.$currency.multiplier
        }
        return false
      },
      set(newValue) {
        this.localdelivery.free_shipping = parseInt((parseFloat(newValue)).toFixed(this.$currency.exponent).replace('.', ''))
      }
    }
  },
  mounted () {
    this.fetchShippingLocalDelivery()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    openLocalDeliveryDetails (shipping) {
      this.selectedShipping = shipping
      this.showUpdateLocalDeliveryMethod = true
    },
    shippingObject(localdelivery) {
      let selectedShippings = []
      let shippings = []
      if (Object.keys(this.localdelivery).length > 0) {
        selectedShippings = this.localdelivery.available_shipping.filter(f => f.enabled)
        shippings = this.localdelivery.available_shipping
      }
      let shipping = shippings.find(f => f.title === localdelivery.name)
      const choices = shippings.filter(f => f.title === localdelivery.name)
      let selectedShipping = selectedShippings.filter(f => f.title === localdelivery.name)
      let isSelected = selectedShipping.length > 0

      if (!shipping) {
        return { out_of_service: true, enabled: isSelected }
      }
      let isPrefered = this.localdelivery.preferred ===  shipping.service_id
      return {...shipping, name: localdelivery.name, ref_id: localdelivery.id, enabled: isSelected, preferred: isPrefered, choices: choices, data: shipping }
    },
    onUpdateLocalDelivery (shipping, updateBoth) {
      let selectedShippings = this.localdelivery.available_shipping.filter(f => f.enabled)
      let selectedShipping = selectedShippings.filter(f => f.title === shipping.name)
      this.localdelivery.available_shipping.filter(f => f.title === shipping.name).forEach(o => {
        if (selectedShipping.length > 0) {
          this.$set(this.localdelivery.available_shipping[this.localdelivery.available_shipping.findIndex(f => f.service_id === o.service_id)], 'enabled', false)
        } else {
          if (updateBoth) {
            this.$set(this.localdelivery.available_shipping[this.localdelivery.available_shipping.findIndex(f => f.service_id === o.service_id)], 'enabled', true)
          }
        }
      })
      this.localdelivery.selected_shipping = this.localdelivery.available_shipping.filter(f => f.enabled)
    },
    fetchShippingLocalDelivery() {
      this.isFetching = true
      this.$axios.get(`/shipping/yezzashipping/settings/${this.company.slug}/local_delivery`)
        .then((response) => {
          this.localdelivery = JSON.parse(JSON.stringify(response.data))
          this.originalLocalDelivery = JSON.parse(JSON.stringify(response.data))
        }).catch(() => {})
        .finally(() => { this.isFetching = false })
    },
    clickRevert () {
      this.localdelivery = JSON.parse(JSON.stringify(this.originalLocalDelivery))
      this.addressChanged = false
    },
    updateAddress () {
      this.addressChanged = (JSON.stringify(this.localdelivery.pickup_address) !== JSON.stringify(this.originalLocalDelivery.pickup_address))
    },
    async clickSave () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      await this.axios.patch(`/shipping/yezzashipping/settings/${this.company.slug}/local_delivery/${this.localdelivery.id}`, this.localdelivery)
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.message) {
            this.showMessage(['error', e.response.data.message])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
        })
      await this.$axios.get(`/shipping/yezzashipping/settings/${this.company.slug}/local_delivery`)
        .then((response) => {
          this.localdelivery = { ...response.data }
          this.originalLocalDelivery = { ...response.data }
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "yezza_shipping_text": "Enjoy fast, reliable logistic services with our delivery partners.. autogenerate AWB...",
    "on_demand_services": "On-demand services",
    "on_demand_services_text": "Enable desired delivery services below",
    "not_available_your_area": "Not available in your area",
    "delivery_rates": "Delivery rates",
    "use_automatic_delivery_rates": "Use automatic delivery rates",
    "charge_based_on_weight": "Charge the most accurate rates based on weight, destination and delivery services",
    "customize_shipping_rate": "Customize your shipping rates",
    "markup_rates": "Markup rates",
    "markup_rates_text": "Charge additional markup amount on top of real time rates",
    "markup_amount": "Markup amount",
    "markup_amount_text": "This amount will be added to calculated real time rate",
    "markup_example": "Example: Markup amount = RM 4.00",
    "markup_example_time": "time rates = RM 5.00",
    "markup_example_fee": "fee charge = RM 12.00",
    "flat_rate": "Flat rate",
    "flat_rate_text": "Charge one flat rate for every order regardless of weight, destination or localdelivery service",
    "flat_rate_info": "This rate will be offered to all customers who require shipping",
    "section_offer_free": {
      "title": "Offer customers free shipping",
      "pays_full": "Merchant pays the full shipping fee for orders over a certain amount.",
      "order_amount": "Order amount",
      "order_amount_text": "Free shipping automatically offered when total order exceeds this amount"
    },
    "section_address": {
      "title": "Address for localdelivery",
      "text": "Manage your pickup address & Air Waybill (AWB) address",
      "pickup_address": "Pickup address"
    }
  },
  "id": {
    "yezza_shipping_text": "Nikmati layanan logistik yang cepat dan kamul dengan mitra pengiriman kami...buat AWB secara otomatis...",
    "on_demand_services": "Permintaan jasa",
    "on_demand_services_text": "Aktifkan jasa pengiriman yang diinginkan di bawah ini",
    "not_available_your_area": "Tidak tersedia di wilayah kamu",
    "delivery_rates": "Tarif pengiriman",
    "use_automatic_delivery_rates": "Gunakan tarif pengiriman otomatis",
    "charge_based_on_weight": "Mengenakan biaya paling akurat berdasarkan berat, tujuan, dan layanan kurir",
    "customize_shipping_rate": "Sesuaikan tarif pengiriman kamu",
    "markup_rates": "Markup Rate",
    "markup_rates_text": "Kenakan jumlah biaya markup tambahan di atas tarif waktu nyata",
    "markup_amount": "Jumlah markup",
    "markup_amount_text": "Jumlah ini akan ditambahkan untuk menghitung tarif waktu nyata",
    "markup_example": "Contoh: Jumlah markup = Rp 40.00",
    "markup_example_time": "tarif waktu = Rp 50.00",
    "markup_example_fee": "biaya = Rp 120.00",
    "flat_rate": "Flat rate",
    "flat_rate_text": "Kenakan biaya satu flat rate untuk setiap pesanan tanpa mementingkan berat, tujuan dan jasa kurir",
    "flat_rate_info": "Rate ini akan ditawarkan untuk semua pelanggan yang membutuhkan pengiriman",
    "section_offer_free": {
      "title": "Tawarkan gratis ongkir kepada pelanggan",
      "pays_full": "Penjual membayar ongkir penuh untuk pesanan dalam jumlah tertentu.",
      "order_amount": "Jumlah pesanan",
      "order_amount_text": "Gratis ongkir secara otomatis ditawarkan ketika total pesanan melebihi jumlah ini"
    },
    "section_address": {
      "title": "Alamat untuk kurir",
      "text": "Kelola alamat pengambilan kamu & alamat Air Waybill (AWB)",
      "pickup_address": "Alamat pengambilan"
    }
  }
}
</i18n>
